var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.01367 24.2738C6.74397 24.1058 7.49701 24.0199 8.2592 24.0199H10.0313C10.5339 16.1173 17.0436 9 25.0001 9C32.9566 9 39.4663 16.1173 39.9689 24.0199H41.741C42.5032 24.0199 43.2562 24.1058 43.9865 24.2738C43.6057 14.0721 35.2509 5 25.0001 5C14.7493 5 6.39458 14.072 6.01367 24.2738Z",
    clipRule: "evenodd",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.439 27.2514C45.1887 26.4458 43.7382 26.0199 42.2441 26.0199H38.7002V44.5111H42.2441C46.5208 44.5111 50 41.0318 50 36.7552V33.7757C50 31.126 48.6686 28.6869 46.439 27.2514Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.2998 26.0199H7.75586C6.26182 26.0199 4.81133 26.4457 3.56162 27.251C1.33145 28.6869 0 31.126 0 33.7758V36.7552C0 41.0318 3.4793 44.5111 7.75586 44.5111H11.2998V26.0199Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.c769eb0d08d0d2a4cf66778e05e96cf8.svg";
export { ForwardRef as ReactComponent };